import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
    loadClaimEventStatuses,
    loadClaimEventTypes,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { hasRole, PRAP, QUALITY, SUPERUSER } from '../../../utils/userRoles';
import SingleSelect from '../../formElements/SingleSelect';
import TextInputField from '../../formElements/TextInputField';

import form from '../../../commonStyles/formStyles.module.css';
const editRoles = [PRAP, QUALITY, SUPERUSER];

const ModalContentCTWReferral = ({ contracts = [], errors, selects, onChange }) => {
    // HOOKS
    const dispatch = useDispatch();

    // LOCAL STATE
    const [claimEventType, setClaimEventType] = useState({});
    const [claimEventStatus, setClaimEventStatus] = useState({});
    const [triggerChange, setTriggerChange] = useState(false);

    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);
    const claimEventTypes = useSelector((state) => state.entities.directusService.claimEventTypes);
    const claimEventStatuses = useSelector(
        (state) => state.entities.directusService.claimEventStatuses
    );
    const serviceDetailsForContractId = useSelector(
        (state) => state.entities.directusService.serviceDetailsForContractId
    );

    // USE EFFECTS
    useEffect(() => {
        claimEventTypes?.length < 1 && dispatch(loadClaimEventTypes());
        claimEventStatuses?.length < 1 && dispatch(loadClaimEventStatuses());
    }, []);

    useEffect(() => {
        if (claimEventTypes.length < 1 || claimEventStatuses.length < 1) return;
        setClaimEventType(claimEventTypes.find((el) => el.name.toLowerCase() === 'referral'));
        setClaimEventStatus(claimEventStatuses.find((el) => el.name.toLowerCase() === 'verified'));
        setTriggerChange(true);
    }, [claimEventTypes, claimEventStatuses]);

    useEffect(() => {
        onChange('claimEventType', claimEventType);
        onChange('claimEventStatus', claimEventStatus);
    }, [triggerChange]);

    useEffect(() => {
        onChange('service', {});
    }, [serviceDetailsForContractId]);

    useEffect(() => {
        selects.contract?.id && dispatch(loadServiceDetailsForContractId(selects.contract.id));
    }, [selects.contract]);

    // RENDER
    return (
        <div className={form.formSection}>
            <div className={form.formColumn}>
                <TextInputField
                    id={'claimEventType'}
                    label={'Claim Type'}
                    disabled={true}
                    value={claimEventType?.name || ''}
                    onChange={(chosenId) => onChange('claimEventType', chosenId)}
                />
                <TextInputField
                    id={'claimEventStatus'}
                    label={'Claim Status'}
                    disabled={true}
                    value={claimEventStatus?.name || ''}
                    onChange={(chosenId) => onChange('claimEventStatus', chosenId)}
                />
            </div>
            <div className={form.formColumn}>
                <SingleSelect
                    id="contract"
                    label="Contract"
                    placeholder="Select contract..."
                    disabled={!hasRole(editRoles, roles)}
                    mandatory={true}
                    customClass="absoluteAndHeightControlSecondLevel"
                    menuItems={contracts}
                    selectedId={selects.contract?.id || ''}
                    selected={
                        (selects.contract?.id &&
                            contracts.find((el) => el.id === selects.contract.id)) ||
                        {}
                    }
                    error={errors.contract}
                    onChange={(id) =>
                        onChange(
                            'contract',
                            contracts.find((el) => el.id === id)
                        )
                    }
                />
                <SingleSelect
                    id="service"
                    label="Service"
                    placeholder="Select service..."
                    disabled={serviceDetailsForContractId.length === 0 || !selects.contract?.id}
                    mandatory={true}
                    customClass="absoluteAndHeightControl"
                    menuItems={serviceDetailsForContractId || []}
                    selectedId={selects.service?.id || ''}
                    selected={
                        (selects.service?.id &&
                            serviceDetailsForContractId.find(
                                (el) => el.id === selects.service.id
                            )) ||
                        {}
                    }
                    error={errors.service}
                    onChange={(id) =>
                        onChange(
                            'service',
                            serviceDetailsForContractId.find((el) => el.id === id)
                        )
                    }
                />
            </div>
        </div>
    );
};

ModalContentCTWReferral.propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    selects: PropTypes.object,
    onChange: PropTypes.func
};

export default ModalContentCTWReferral;
